import React from 'react';
import { TextProps as ReactTextProps } from 'react-native';

import { Container, TextLabel } from './styles';

interface TextProps extends ReactTextProps {
  color?: string;
}

const Text: React.FC<TextProps> = ({ children, ...rest }) => {
  return (
    <Container>
      <TextLabel {...rest}>{children}</TextLabel>
    </Container>
  );
};

export default Text;
